var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"apptbutton"}},[_c('b-button',{staticClass:"mt-3 shadow",attrs:{"squared":"","block":_vm.block,"variant":_vm.col},on:{"click":_vm.route}},[_vm._v("\n    "+_vm._s(_vm.$t("common.make-appointment"))+"\n    "),_c('b-icon',{attrs:{"icon":"chevron-right","font-scale":"0.95","aria-hidden":"true"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-395f031d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/ApptButton.vue
// module id = 852
// module chunks = 1